<template>
    <div>
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="12">
                        Reporte de resultados
                    </v-col>
                     
            
                </v-row>

                <v-row class="col-md-12">

                    <v-col cols="12" sm="12" md="12" xs="12" class="pt-0 pb-3">
                        <v-btn
                            color="warning"
                            class="mb-2 float-right bg-light-blue"
                            @click="restablecerFiltros();"
                        >
                            Restablecer filtros
                            <v-icon right>mdi-delete</v-icon>
                        </v-btn>
                    </v-col> 

                
                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                        <v-select
                            v-model="periodoMedicionId"
                            :items="periodos"
                            :loading="ddPeriodosLoading"
                            dense
                            outlined
                            label="Periodo de medición"
                            item-text="anioMedicion"
                            item-value="id"
                            return-object
                            :no-data-text="periodos!=null ? 'Selecciona un periodo' : 'No se han encontrado periodos'"
                            menu-props="auto"
                        ></v-select>
                    </v-col>

                     <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                        <v-autocomplete
                            v-model="indiceId"
                            :items="indices"
                            dense
                            outlined
                            :loading="ddIndicesLoading"
                            label="Seleccionar Índice"
                            item-text="nombreIndice"
                            item-value="id"
                            return-object
                            ></v-autocomplete>
                    </v-col> 

                    <!-- <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                        <v-select
                            v-model="departamentoId"
                            :items="deptos"
                            dense
                            outlined
                            :loading="ddDeptosLoading"
                            label="Departamento"
                            item-text="nombreDepartamento"
                            item-value="id"
                            return-object
                            menu-props="auto"
                            @change="obtnenerMunicipiosPorDepto()"
                            
                            
                        >
                            <template slot='selection' slot-scope='{ item }'>
                                    <v-row>
                                        <v-col cols="12">
                                            {{ item.codigo }} - {{ item.nombreDepartamento }}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    <v-row>
                                        <v-col cols="12">
                                            {{ item.codigo }} - {{ item.nombreDepartamento }} <br/> 
                                        </v-col>
                                    </v-row>
                                </template>
                        </v-select>
                    </v-col>


                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                        <v-select
                            v-model="municipioId"
                            :items="municipios"
                            dense
                            outlined
                            :loading="ddMunicipiosLoading"
                            item-text="nombreMunicipio"
                            item-value="id"
                            return-object
                            label="Municipio"
                            menu-props="auto"
                            
                            
                        >
                            <template slot='selection' slot-scope='{ item }'>
                                    <v-row>
                                        <v-col cols="12">
                                            {{ item.codigo }} - {{ item.nombreMunicipio }}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    <v-row>
                                        <v-col cols="12">
                                            {{ item.codigo }} - {{ item.nombreMunicipio }} <br/> 
                                        </v-col>
                                    </v-row>
                                </template>
                        </v-select>
                    </v-col> -->
                    <!--@change="obtenerAprobadoresRevisoresAsignados(); obtnenerMunicipiosPorDepto()"-->

                   
                

                    <v-col cols="12" sm="3" md="3" xs="12" class="pt-0 pb-0">
                        <v-btn
                            color="primary"
                            class="mb-2 float-left bg-light-blue"
                            @click="obtenerReporte();"
                            :disabled="periodoMedicionId==0 || indiceId.id ==0"
                            :loading="mostrarReporteLoading"
                        >
                            Mostrar reporte
                            <v-icon right>mdi-magnify</v-icon>
                        </v-btn>
                    </v-col> 
                </v-row>

                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>

            
                        
            <v-card-text>
                <v-progress-linear
                    :active="resultadosLoading"
                    :indeterminate="resultadosLoading"
                    absolute
                    bottom
                    color="deep-purple accent-4"
                ></v-progress-linear>

                <SubHeader subHeaderTitle="Reporte de resultados" v-if="itemsIndices.length>0"/>

                <small class="text-h6 font-italic light-blue--text darken-3--text">{{nombreMunicipioSeleccionado}}</small>

                <!-- INDICE POR DEPARTAMENTO -->
                 <v-data-table
                        v-if="itemsIndices.length>0"
                        :headers="headersIndices"
                        :items="itemsIndices"
                        item-key="Id"
                        class="elevation-0 mb-4"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :search="tableFilter"
                        :items-per-page="10"
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            'items-per-page-text':'Registros por página',
                            pageText: '{0}-{1} de {2}' 
                        }"
                        dense
                    >
                    <template v-slot:item="{ item }" >
                        <tr>
                            <td>{{ item.posicion }}</td>
                            <td>{{ item.codDepartamento }} - {{item.departamento}}</td>
                            <td>{{ item.codMunicipio }} - {{item.municipio}}</td>
                            <td>{{ item.resultado }}</td>
                            <!--<td>
                                <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>
                            </td>-->
                        </tr>
                    </template>

                </v-data-table>

                 <!-- <BarChart :datos="datosBarChart"
                            :key="barChartKey"/> -->

                <!-- Inicio:: Ingreso de la información a importar -->
                <v-form ref="myForm"
                    v-on:submit.prevent="registrarResultados"
                    v-model="validForm">
                        <v-row class="mt-4" v-for="campo in camposResultados" :key="campo.id">
                        
                            <v-col md="12" sm="12">

                        
                                <v-card
                                    elevation="1"
                                    class="mb-2"
                                    >
                                    <v-card-title>{{campo.codigoCampo}}</v-card-title>

                                    <v-card-text>
                                        <v-row
                                            align="center"
                                            class="mx-0"
                                        >

                                            <div class="col-md-6 col-sm-6 col-sm-12">
                                                        
                                                <v-text-field
                                                    label="Valor"
                                                    dense
                                                    outlined
                                                    v-model="valoresResultadoAlmacenados[`${campo.camposMuniPeriodoId}`]"
                                                    :rules="[maxNumber('valor',1), required('valor')]"
                                                    v-mask="'#.##'"
                                                    class="required"
                                                    >
                                                </v-text-field>
                                            </div>

                                            <div class="col-md-6 col-sm-6 col-sm-12">
                                                <v-select
                                                    v-model="categoriasResultadoAlmacenados[`${campo.camposMuniPeriodoId}`]"
                                                    :items="categoriasResultado"
                                                    dense
                                                    outlined
                                                    label="Categoría"
                                                    item-text="categoria"
                                                    item-value="id"
                                                    :no-data-text="categoriasResultado!=null ? 'Selecciona una categoría' : 'No se han encontrado categorías'"
                                                    menu-props="auto"
                                                    class="required"
                                                    :rules="[
                                                        selectRequired(
                                                            'Departamento'
                                                        )
                                                    ]"
                                                ></v-select>
                                            </div>

                                        </v-row>

                                    </v-card-text>
                                
                                </v-card>

                            </v-col>

                                <!-- <v-row>
                                    
                                    <v-divider></v-divider>
                                </v-row> -->
                            
                       
                        </v-row>
                    </v-form>

                <!-- Fin:: Ingreso de la información a importar -->

                
            </v-card-text>
        </v-card>


    <!-- Fin:: Dialog para mostrar los datos de la puesto-->

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>

<script>
import Vue from 'vue';
import moment from "moment";

import validations from "@/core/untils/validations.js";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_INDICES } from "@/core/services/store/catalogos/indice.module";
import { OBTENER_DEPARTAMENTOS} from "@/core/services/store/catalogos/departamento.module";
import { OBTENER_MUNICIPIOS_POR_DEPTO } from "@/core/services/store/catalogos/municipio.module";
import { OBTENER_BOLETAS } from "@/core/services/store/boletas/boleta.module";
import { OBTENER_BOLETA_MUNI } from "@/core/services/store/boletas/boletamuni.module";
//import { OBTENER_CAMPOS_MUNI_POR_INDICE_PERIODO_DEPTO_MUNI } from "@/core/services/store/camposresultados/camposmuniperiodo.module";
import { REGISTRAR_RESULTADOS_MUNI, OBTENER_REPORTE_RESULTADOS_MUNI, OBTENER_REPORTE_CATEGORIAS_RESULTADOS_MUNI } from "@/core/services/store/resultados/resultados.module";
import { OBTENER_PERIODOS } from "@/core/services/store/catalogos/periodomedicion.module";
import SnackAlert from '@/view/content/SnackAlert.vue';
import SubHeader from "@/view/components/subheader/SubHeader";
import DialogLoader from "@/view/content/DialogLoader";

// import BarChart from "@/view/components/charts/BarChart";

moment.locale('es');
Vue.filter("formatDate", function(value) {
    if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
    }
});

export default {
   
    name: "Asigboletas",
    // extends: VueChartJs.Pie,
    components: {
        SnackAlert, 
        DialogLoader,
        SubHeader,
        // BarChart
    },
    data() {
        return {
            tableLoading: false,
            tableFilter:'',
            validForm:false,
            itemName : "Campos",
            dialog: false,
            modalTitle: 'Asignar Campos',
            btnRegistroLoading: false,
            dialogLoaderVisible: false,
            activePicker:null,
            tipoSeleccionMunis: 0,
            tiposSeleccion: [{id: 1, nombre: 'Todas las municipalidades'}, {id: 2, nombre: 'Seleccionar de forma parcial'}],
            departamentoId: {id: 0, nombreDepartamento: null},
            deptos: [],
            ddDeptosLoading: false,
            municipios: [],
            municipioId: 0,
            nombreMunicipioSeleccionado: '',
            categoriasResultado: [{id: 1, categoria: 'Baja'}, {id: 2, categoria: 'Media Baja'}, {id: 3, categoria: 'Media'}, {id: 4, categoria: 'Media Alta'}, {id: 5, categoria: 'Alta'}],
            valoresResultadoAlmacenados:{},
            categoriasResultadoAlmacenados:{},
            resultadosLoading: false,
            ddMunicipiosLoading: false,
            tipoSeleccion: 1, //Se utiliza para definir si los reportes son generales (1), por departamento (2), por municipio (3)
            indiceSeleccionado: [{id: 0, nombre: ''}],
            boletasMuni: [],
            camposResultados:[],
            ddBoletasLoading: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Registrar Boleta',
            accion: 1,
            indices: [],
            indiceId: 0,
            ddIndicesLoading: false,
            ddPeriodosLoading: false,
            periodos: [],
            periodoMedicionId:0,
            switchItemEstado: true,
            datosItem: {
                id: 0,
                listaMunicipalidades:[],
                indiceId:0,
                estadosId: 1
            },
            datosResultados:{
                estadosId:1,
                listaResultados:[],
            },
            municipiosSeleccionados:[],
            ...validations,
            mostrarReporteLoading:false,
            datacollection: null,
            datosBarChart:[],
            barChartKey:0,
            barChartRender:false,
            etiquetas: [],
            valores: [],
            indiceDeptos:[],
            headersIndiceDeptos:[],
            itemsIndices: []
            
        } 
    }, 
    methods: {
        toggle () {
        this.$nextTick(() => {
          if (this.likesAllMunicipios) {
            this.municipiosSeleccionados = []
          } else {
            this.municipiosSeleccionados = this.municipios.slice()
          }
        })
      },

        //!Definir la fecha máxima que se puede seleccionar en el datepicker
        maxDate() {
            const date = new Date();
            date.setFullYear(date.getFullYear() + 1);
            return date.toISOString().substr(0, 10);
        },

        //!Definir la fecha minima que se puede seleccionar en el datepicker
        minDate() {
            const date = new Date();
            date.setFullYear(date.getFullYear());
            return date.toISOString().substr(0, 10);
        },


        modalNueva(){
            this.accion =1;
            this.modalTitle='Asignar Campos';
            this.btnRegistroText='Asignar Campos';
            this.switchItemEstado=true;
            this.indiceSeleccionado= [{id: 0, nombre: ''}];
            this.dialog=true;
        },

        resetForm(){
           // this.$refs.form.reset();
           
             this.datosItem= {
                id: 0,
                listaMunicipalidades:[],
                indiceId:0,
                estadosId: 1
            };
            this.indiceSeleccionado= [{id: 0, nombre: ''}];
            this.switchItemEstado = true;
            //console.log(this.switchItemEstado)
        },

        restablecerFiltros(){
            this.periodoMedicionId = 0;
            //this.departamentoId = 0;
            this.departamentoId ={id: 0, nombreDepartamento: null};
            this.municipioId = 0;
            this.indiceId= {id: 0, nombreIndice: null};
        },


        //Obtener listado de índices
         async obtenerIndices(){
            this.indices=[];
            this.ddIndicesLoading=true;
            await this.$store
            .dispatch(OBTENER_INDICES, 1)
            .then(res => {
                if(res.status===200){
                    this.indices=res.data;
                } else {
                    console.warn(res.message)
                }
                this.ddIndicesLoading=false;
               
            }
            )
            .catch(() => {
                this.ddIndicesLoading=false;
                //console.warn(err)
            });


        },

        //!Obtener los periodos para la tabla
        obtnenerPeriodosMedicion(){
            this.ddPeriodosLoading = true;
            this.periodos=[];
            
            this.$store
                .dispatch(OBTENER_PERIODOS)
                .then(() => {
                    this.periodos = this.$store.state.periodomedicion.periodos;
                    this.ddPeriodosLoading =false;
                })
                .catch(() => {
                    this.ddPeriodosLoading = false;
                });

        },

        //!Obtener los departamentos para la tabla
        async obtnenerDepartamentos(){
            this.ddDeptosLoading = true;
            this.deptos=[];
            
            await this.$store
                .dispatch(OBTENER_DEPARTAMENTOS,1)
                .then(res => {
                    if(res.status==200){
                        this.deptos = this.$store.state.departamento.departamentos;
                    }
                    this.ddDeptosLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.ddDeptosLoading = false;
                });

        },


        //!Obtener las etnias para la tabla
        async obtnenerMunicipiosPorDepto(){

           this.municipioId=0;
            this.ddMunicipiosLoading = true;
            this.municipios=[];
            
            await this.$store
                .dispatch(OBTENER_MUNICIPIOS_POR_DEPTO, {departamentoId: this.departamentoId.id, estadoId: 1})
                .then(res => {
                    if(res.status==200){
                        this.municipios = this.$store.state.municipio.municipios;
                    }
                    this.ddMunicipiosLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.ddMunicipiosLoading = false;
                });

        },

        //!Obtener las boletas para la llenar el dropdown
        obtnenerBoletas(){
            this.ddBoletasLoading = true;
            this.boletas=[];
            
            this.$store
                .dispatch(OBTENER_BOLETAS, {estadoId: 0, idPeriodo: this.datosItem.periodoMedicionId, idIndice: 0})
                .then(res => {
                    if(res.status===200){
                        this.boletas = this.$store.state.boleta.boletas;
                    }
                    this.ddBoletasLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.ddBoletasLoading = false;
                });

        },

        /*//!Obtener el reporte de los índices
        async obtenerReporte(){
            
            //!Generar el tipo de seleccion en base a los filtros seleccionados (Periodo, Departmamento y Municipio)

            if(this.municipioId.id == 0)


            this.tableLoading = true;
            this.camposResultados=[];
            this.categoriasResultadoAlmacenados={};
            this.valoresResultadoAlmacenados ={};
            this.resultadosLoading=true;
            await this.$store
                .dispatch(OBTENER_CAMPOS_MUNI_POR_INDICE_PERIODO_DEPTO_MUNI, {periodoId: this.periodoMedicionId.id, indiceId: this.indiceId, deptoId: this.departamentoId.id, municipioId: this.municipioId.id })
                .then(res => {
                    if(res.status===200){
                    
                        this.camposResultados = this.$store.state.camposmuniperiodo.camposResultados;
                        this.nombreMunicipioSeleccionado = this.municipioId.nombreMunicipio;

                        this.obtenerResultadosAlmacenados();
                    }
                   
                //console.log(this.etnias)
                })
                .catch(() => {
                    
                    this.resultadosLoading=false;
                   // console.log(err)
                });

        },*/

        //!Obtener el reporte de los índices
        async obtenerReporte(){

            this.mostrarReporteLoading=true;
            this.tableLoading=true;
            this.etiquetas=[];
            this.valores=[];
            this.itemsIndices=[];

            await this.$store
            .dispatch(OBTENER_REPORTE_RESULTADOS_MUNI, {periodoId: this.periodoMedicionId.id, deptoId: this.departamentoId.id, municipioId: this.municipioId, indiceId: this.indiceId.id })
            .then(res => {
                if(res.status===200){
                    this.obtenerCategoriasResultados();
                    this.etiquetas=[];
                    this.valores=[];
                    

                    let registros = res.data;
                    let customRegistros=[];
                   // console.log(registros)
                    

                    //!Generar la gráfica en base a los filtros seleccionados
                    if(this.departamentoId.id===0 && this.municipioId===0 && this.indiceId.id===0){
                        registros.forEach(element=> {
                            this.etiquetas.push(element.codigo);
                            this.valores.push(element.average);
                        });
                    }
                    else if(this.departamentoId.id===0 && this.municipioId===0 && this.indiceId.id>0){
                        let order = 1;
                        registros.forEach(element=> {
                           // this.etiquetas.push(element.municipio);
                           // this.valores.push(element.resultado);

                            customRegistros.push({posicion: order, codDepartamento: element.codDepartamento, departamento: element.departamento, codMunicipio: element.codMunicipio, municipio : element.municipio, resultado: element.resultado });

                            order++;
                        });

                        this.itemsIndices = customRegistros;
                        //console.log(this.itemsIndices)

                    }

                    else if(this.departamentoId.id>0 && this.municipioId===0 && this.indiceId.id>0){
                        registros.forEach(element=> {
                            this.etiquetas.push(element.municipio);
                            this.valores.push(element.resultado);

                            
                        });
                    }

                    else if(this.departamentoId.id>0 && this.municipioId>0 && this.indiceId.id>0){
                        registros.forEach(element=> {
                            this.etiquetas.push(element.codigo);
                            this.valores.push(element.resultado);
                        });
                    }


                    

                    
                }
                this.mostrarReporteLoading=false;
                
            //console.log(this.etnias)
            })
            .catch(() => {
                
                this.mostrarReporteLoading=false;
                this.tableLoading=false;
                // console.log(err)
            });
        },

        async obtenerCategoriasResultados(){
            this.datosBarChart=[];
             await this.$store
            .dispatch(OBTENER_REPORTE_CATEGORIAS_RESULTADOS_MUNI, {periodoId: this.periodoMedicionId.id, deptoId: this.departamentoId.id, municipioId: this.municipioId, indiceId: this.indiceId.id })
            .then(res => {
                if(res.status===200){
                    let cats = res.data;

                    if(this.departamentoId.id===0 && this.municipioId===0 && this.indiceId.id>0){
                       
                        cats.forEach(element=> {
                            this.etiquetas.push(element.nombreCategoria);
                            this.valores.push(element.valor);
                        });
                    }

                    this.datosBarChart = [
                        this.etiquetas,
                        this.valores
                    ];

                    this.barChartRender=true;
                    this.barChartKey+=1;
                }
                this.tableLoading=false;
            })
            .catch(() => {
                this.tableLoading=false;
                this.mostrarReporteLoading=false;
                // console.log(err)
            });
            
        },

        //!Generar la gráfica
        fillData () {
            this.datacollection = {
            labels: ["Prueba 1", "Prueba 2"],
            datasets: [
                {
                label: 'Data One',
                backgroundColor: '#f87979',
                data: [3, 4]
                }, {
                label: 'Data One',
                backgroundColor: '#f87979',
                data: [5, 15]
                }
            ]
            }
        },
        

        //!Obtener los registros para la tabla
        obtnenerItems(){
            this.tableLoading = true;
            this.boletas=[];
            
            this.$store
                .dispatch(OBTENER_BOLETAS, 0)
                .then(() => {
                    this.boletas = this.$store.state.boleta.boletas;
                    this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },

        obtenerDatosItem(Id){
            this.dialogLoaderVisible=true;
            this.datosItem.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar Asignación';
            this.btnRegistroText='Actualizar Asignación';

            this.$store
                .dispatch(OBTENER_BOLETA_MUNI, Id)
                .then(res => {
                   
                    if(res.status===200){
                        this.datosItem = this.$store.state.boleta.boleta;
                        this.indiceSeleccionado.id = this.datosItem.boletaId;
                        this.indiceSeleccionado.descripcion = this.datosItem.descripcion;

                        //console.log(this.datosItem)
                        this.datosItem.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                        this.dialog = true;
                    } else {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    //console.log(this.datosItem)
                   
                    this.dialogLoaderVisible = false;
                })
                .catch(error => {
                    this.dialogLoaderVisible = false;
                    console.log(error)
                });
        },

        async registrarResultados(){

            for (var key of Object.keys(this.valoresResultadoAlmacenados)) {
                //console.log(key + " -> " + this.respuestasPregunta[key])

                this.datosResultados.listaResultados.push({camposMuniPeriodoId: parseInt(key), resultado: this.valoresResultadoAlmacenados[key].toString(), categoriaResultadoId: parseInt(this.categoriasResultadoAlmacenados[key])});
            }

            this.datosResultados.estadosId =1;


            this.btnRegistroLoading=true;
            await this.$store
            .dispatch(REGISTRAR_RESULTADOS_MUNI, this.datosResultados)
            .then(res => {
                //console.log(res)
                if(res.status===200){
                    this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                    
                } else {
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                }
                this.btnRegistroLoading=false;
                this.dialogLoaderVisible=false;
                this.datosResultados.listaResultados=[];
            })
            .catch(error => {
                console.log(error)
                this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                this.btnRegistroLoading=false;
                this.dialogLoaderVisible=false;
                this.datosResultados.listaResultados=[];
            });

            
            //console.log(this.datosResultados);
        }
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Resultados" },
            { title: "Reportes" }
        ]);

      
    },

    created(){
        this.obtenerIndices();
       // this.obtnenerBoletasMuni();
        this.obtnenerDepartamentos();
        this.obtnenerItems();
        //this.obtnenerBoletas();
        this.obtnenerPeriodosMedicion();
    },

    
    computed: {
         likesAllMunicipios () {
            return this.municipiosSeleccionados.length === this.municipios.length
        },
        likesSomeMunicipio () {
            return this.municipiosSeleccionados.length > 0 && !this.likesAllMunicipios
        },
        icon () {
            if (this.likesAllMunicipios) return 'mdi-close-box'
            if (this.likesSomeMunicipio) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        headersIndices() {
            return [
                /*{
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },*/
                {
                    text: "Posición",
                    value: "posicion"
                },
                {
                    text: "Departamento",
                    value: "departamento"
                },
                {
                    text: "Municipio",
                    value: "municipio"
                },
                {
                    text: "Índice",
                    value: "indice"
                }/*,
                {
                    text: "Acciones",
                    value: "Acciones"
                }*/
            ]
        } ,

        headers() {
            return [
                /*{
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },*/
                {
                    text: "Año de Medición",
                    value: "anioMedicion"
                },
                {
                    text: "Código del campo",
                    value: "codigoCampo"
                },
                {
                    text: "Municipio",
                    value: "nombreMunicipio"
                },
                {
                    text: "Estado",
                    value: "estadosId"
                }/*,
                {
                    text: "Acciones",
                    value: "Acciones"
                }*/
            ]
        }   
    },
    
}
</script>
<style lang="">
    
</style>